import { render, staticRenderFns } from "./ReturnHeader.vue?vue&type=template&id=f6af10ac&scoped=true&"
import script from "./ReturnHeader.vue?vue&type=script&lang=js&"
export * from "./ReturnHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReturnHeader.vue?vue&type=style&index=0&id=f6af10ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af10ac",
  null
  
)

export default component.exports